import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';

dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
export default class ServiceContent {
  constructor({
    titre: name,
    activites_operationnelles: unitType,
    numero_tel: phones,
    url,
    mmpec,
    patientele,
    mode_prise_en_charge: supportedMode,
    categorie_organisation: organization,
    public_pris_en_charge: supportedPublic,
    labels,
    type_de_service: serviceKind,
  }) {
    this.name = name || '';
    this.unitType = unitType || [];
    this.serviceKind = serviceKind;
    this.phones = phones || [];
    this.url = url;
    this.mmpec = mmpec;
    this.patientele = patientele;
    this.supportedMode = supportedMode;
    this.organization = organization;
    this.supportedPublic = supportedPublic;
    this.labels = labels || [];
  }

  getName() {
    return this.name;
  }

  getServiceKind() {
    return this.serviceKind || '';
  }

  getUnitType() {
    return this.unitType.join(', ');
  }

  getUnitTypeArray() {
    return this.unitType;
  }

  getPhones() {
    return this.phones;
  }

  getPhonesStriped() {
    return this.phones.map((phone) => encodeURIComponent(phone.replaceAll(/[^0-9+]/g, '')));
  }

  getUrl() {
    return this.url;
  }

  getMmpec() {
    return this.mmpec;
  }

  getPatientele() {
    return this.patientele || '';
  }

  getSupportedMode() {
    return this.supportedMode;
  }

  getOrganization() {
    return this.organization;
  }

  getSupportedPublic() {
    return this.supportedPublic;
  }

  getLabels() {
    return this.labels;
  }

  getActiveLabels() {
    const today = dayjs();
    return this.labels.filter((label) => (
      (!label.date_publication && !label.date_depublication)
      || (label.date_publication && label.date_depublication && today.isBetween(label.date_publication, label.date_depublication))
      || (label.date_publication && !label.date_depublication && today.isSameOrAfter(label.date_publication))
      || (!label.date_publication && label.date_depublication && today.isSameOrBefore(label.date_depublication)
      )));
  }
}
